class StickyAtc extends HTMLElement {
    constructor() {
        super();
        this.toggleButton = this.querySelector('.sticky-atc__toggle-button');
        this.toggleButton?.addEventListener('click', this.toggleStickyAtc.bind(this));
    }

    toggleStickyAtc() {
        const isExpanded = this.getAttribute('data-expand') === 'true';
        this.setAttribute('data-expand', !isExpanded);
    }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}